import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Chip
} from "@mui/material";
import logo from "./MailExMaxLogoSm.png";

const HomeHeader = ({ logout, serverStatus, deviceCodeData, onChipClick }) => {
  const getStatusColor = (status) => {
    if (deviceCodeData) {
      return "error";
    }
    switch (status) {
      case "online":
        return "success";
      case "offline":
        return "error";
      case "loading":
        return "warning";
      case "error":
        return "error";
      default:
        return "default";
    }
  };

  const getChipLabel = () => {
    if (deviceCodeData) {
      return "Login Required";
    }
    return serverStatus;
  };

  return (
    <AppBar position="static" className="App-header">
      <Toolbar>
        <img src={logo} alt="MailExMax Logo" style={{ height: 40, marginRight: 16 }} />
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          MailExMax
        </Typography>
        <Button color="inherit" onClick={logout}>
          Log Out of MailExMax
        </Button>
        <Box
          component="fieldset"
          sx={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "4px 8px",
            position: "relative",
            marginLeft: "auto",
          }}
        >
          <Typography component="legend" variant="subtitle2" sx={{ padding: "0 8px", color: "#FFFFFF" }}>
            Extractor Status
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Chip
              label={
                <Box display="flex" justifyContent="center">
                  <Typography variant="body2" sx={{ color: "inherit", textTransform: "uppercase" }}>
                    {getChipLabel()}
                  </Typography>
                </Box>
              }
              color={getStatusColor(serverStatus)}
              onClick={onChipClick}
              sx={{ cursor: "pointer", width: 120, height: 40 }}
            />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default HomeHeader;
